import type { Lang } from '@/i18n/LanguageContext';

export interface EventRegistryEntry {
  slug: string;
  name: { en: string; zh: string };
  location: { en: string; zh: string };
  startDate: string;
  endDate: string;
  description: { en: string; zh: string };
}

export const EVENT_REGISTRY: EventRegistryEntry[] = [
  // Global Sources (Hong Kong 2026)
  {
    slug: 'gs-consumer-electronics-2026',
    name: { en: 'Global Sources Consumer Electronics & Components', zh: '环球资源消费电子及电子元器件展' },
    location: { en: 'AsiaWorld-Expo, Hong Kong', zh: '亚洲国际博览馆，香港' },
    startDate: '2026-04-11',
    endDate: '2026-04-14',
    description: {
      en: 'Consumer Electronics, Electronic Components, LED & Solar Products',
      zh: '消费电子、电子元器件、LED及太阳能产品',
    },
  },
  {
    slug: 'gs-mobile-smart-home-2026',
    name: { en: 'Global Sources Mobile Electronics, Smart Home & Lifestyle', zh: '环球资源移动电子、智能家居及生活方式展' },
    location: { en: 'AsiaWorld-Expo, Hong Kong', zh: '亚洲国际博览馆，香港' },
    startDate: '2026-04-18',
    endDate: '2026-04-21',
    description: {
      en: 'Mobile Electronics, Smart Home, Lifestyle Products',
      zh: '移动电子、智能家居、生活方式产品',
    },
  },
  {
    slug: 'gs-sports-fashion-2026',
    name: { en: 'Global Sources Sports & Outdoor, Fashion', zh: '环球资源运动户外及时尚展' },
    location: { en: 'AsiaWorld-Expo, Hong Kong', zh: '亚洲国际博览馆，香港' },
    startDate: '2026-04-27',
    endDate: '2026-04-30',
    description: {
      en: 'Sports & Outdoor, Fashion Accessories, Garments, Fabrics',
      zh: '运动户外、时尚配饰、服装、面料',
    },
  },
  // Canton Fair — Spring 2026 (139th)
  {
    slug: 'canton-fair-spring-2026-phase-1',
    name: { en: 'Canton Fair Spring 2026 — Phase 1', zh: '第139届广交会 — 第一期' },
    location: { en: 'Canton Fair Complex, Guangzhou', zh: '广交会展馆，广州' },
    startDate: '2026-04-15',
    endDate: '2026-04-19',
    description: {
      en: 'Electronics, Home Appliances, Hardware, Auto Parts, Lighting',
      zh: '电子、家电、五金、汽配、照明',
    },
  },
  {
    slug: 'canton-fair-spring-2026-phase-2',
    name: { en: 'Canton Fair Spring 2026 — Phase 2', zh: '第139届广交会 — 第二期' },
    location: { en: 'Canton Fair Complex, Guangzhou', zh: '广交会展馆，广州' },
    startDate: '2026-04-23',
    endDate: '2026-04-27',
    description: {
      en: 'Home Goods, Gifts, Furniture, Decorations',
      zh: '家居用品、礼品、家具、装饰品',
    },
  },
  {
    slug: 'canton-fair-spring-2026-phase-3',
    name: { en: 'Canton Fair Spring 2026 — Phase 3', zh: '第139届广交会 — 第三期' },
    location: { en: 'Canton Fair Complex, Guangzhou', zh: '广交会展馆，广州' },
    startDate: '2026-05-01',
    endDate: '2026-05-05',
    description: {
      en: 'Textiles, Apparel, Toys, Office Supplies, Medical',
      zh: '纺织、服装、玩具、办公用品、医疗',
    },
  },
  // HKTDC Spring 2026
  {
    slug: 'hktdc-gifts-premium-2026',
    name: { en: 'HKTDC Hong Kong Gifts & Premium Fair', zh: 'HKTDC 香港礼品及赠品展' },
    location: { en: 'HKCEC, Hong Kong', zh: '香港会议展览中心，香港' },
    startDate: '2026-04-27',
    endDate: '2026-04-30',
    description: {
      en: 'Gifts, Premiums, Household Products',
      zh: '礼品、赠品、家居用品',
    },
  },
  // HKTDC Autumn 2026
  {
    slug: 'hktdc-electronics-autumn-2026',
    name: { en: 'HKTDC Hong Kong Electronics Fair (Autumn)', zh: 'HKTDC 香港秋季电子产品展' },
    location: { en: 'HKCEC, Hong Kong', zh: '香港会议展览中心，香港' },
    startDate: '2026-10-13',
    endDate: '2026-10-16',
    description: {
      en: 'Audio-Visual, Digital Imaging, Electronic Accessories, I.T. Products',
      zh: '视听产品、数码影像、电子配件、资讯科技产品',
    },
  },
  {
    slug: 'hktdc-security-ict-2026',
    name: { en: 'HKTDC World of Security, ICT Expo', zh: 'HKTDC 国际资讯科技博览' },
    location: { en: 'HKCEC, Hong Kong', zh: '香港会议展览中心，香港' },
    startDate: '2026-10-13',
    endDate: '2026-10-16',
    description: {
      en: 'Security Systems, ICT Solutions, Smart City',
      zh: '安防系统、资讯科技方案、智慧城市',
    },
  },
];

export const DEFAULT_EVENT_SLUG = 'canton-fair-spring-2026-phase-1';

export function getEventBySlug(slug: string): EventRegistryEntry | undefined {
  return EVENT_REGISTRY.find((e) => e.slug === slug);
}

export function getEventDisplay(entry: EventRegistryEntry, lang: Lang) {
  return {
    name: entry.name[lang],
    location: entry.location[lang],
    dates: `${entry.startDate} — ${entry.endDate}`,
    description: entry.description[lang],
  };
}
